module.exports = __webpack_public_path__ + "img/icon-menu.7a71ae0e.svg";